import { render, staticRenderFns } from "./horizontal-widget.vue?vue&type=template&id=61ef0984&"
import script from "./horizontal-widget.vue?vue&type=script&lang=ts&"
export * from "./horizontal-widget.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports